import { render, staticRenderFns } from "./co2.vue?vue&type=template&id=34f7980e&scoped=true&"
import script from "./co2.vue?vue&type=script&lang=js&"
export * from "./co2.vue?vue&type=script&lang=js&"
import style0 from "./co2.vue?vue&type=style&index=0&id=34f7980e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f7980e",
  null
  
)

export default component.exports